import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReportsActivateGuard } from './guards/reports-activate.guard';
import { ReportsDeactivateGuard } from './guards/reports-deactivate.guard';

import { CreateNewActivateGuard } from '../../Common/Misc/services/create-new-activate.guard';
import { ReportComponent } from '../../Common/Reports/components/Report/report.component';
import { SharedReportsComponent } from '../../Common/Reports/components/SharedReportsComponent/shared-reports.component';
import { HypeComponent } from '../../Common/Layout/components/Hype/hype.component';

import { ReportsComponent } from '../Core/components/Reports/reports.component';


const reportRoutes: Routes = [
    {
        path: 'Report',
        component: ReportsComponent,
        canActivate: [ReportsActivateGuard],
        children: [
            {
                path: 'reports',
                children: [
                    {
                        path: '',
                        component: HypeComponent,
                        data: {title: 'Reports.browserTitle'}
                    },
                    {
                        path: 'shared',
                        component: SharedReportsComponent,
                        canDeactivate: [ReportsDeactivateGuard],
                        data: {title: 'Reports.browserTitle'}
                    },
                    {
                        path: 'report',
                        component: ReportComponent,
                        canActivate: [CreateNewActivateGuard],
                        canDeactivate: [ReportsDeactivateGuard],
                        data: {title: 'Reports.browserTitle'}
                    },
                    {
                        path: 'report/:id',
                        component: ReportComponent,
                        canDeactivate: [ReportsDeactivateGuard],
                        data: {title: 'Reports.browserTitle'}
                    }
                ]
            },
            {
                path: '**',
                component: HypeComponent,
                data: {title: 'Reports.browserTitle'}
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(reportRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        ReportsActivateGuard,
        ReportsDeactivateGuard
    ]
})
export class ReportsRoutingModule { }
